import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark';
  });
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    
    // Apply background images
    const publicUrl = process.env.PUBLIC_URL || '';
    const darkBg = `${publicUrl}/backgrounds/background-dark.png`;
    const lightBg = `${publicUrl}/backgrounds/background-light.png`;
    
    const body = document.body;
    const dashboardMain = document.querySelector('.dashboard-main');
    const statisticsContainers = document.querySelectorAll(
      '.statistics-mrp-container, .statistics-junior-container'
    );
    
    const bgUrl = theme === 'light' ? lightBg : darkBg;
    body.style.backgroundImage = `url(${bgUrl})`;
    body.style.backgroundSize = 'cover';
    body.style.backgroundPosition = 'center';
    body.style.backgroundRepeat = 'no-repeat';
    body.style.backgroundAttachment = 'fixed';

    const mobileBg = document.getElementById('mobile-bg');
    if (mobileBg) {
      mobileBg.style.backgroundImage = `url(${bgUrl})`;
    }

    if (dashboardMain) {
      dashboardMain.style.backgroundImage = `url(${bgUrl})`;
      dashboardMain.style.backgroundSize = 'cover';
      dashboardMain.style.backgroundPosition = 'center';
      dashboardMain.style.backgroundRepeat = 'no-repeat';
      dashboardMain.style.backgroundAttachment = 'fixed';
    }
    statisticsContainers.forEach(container => {
      container.style.backgroundImage = `url(${bgUrl})`;
      container.style.backgroundSize = 'cover';
      container.style.backgroundPosition = 'center';
      container.style.backgroundRepeat = 'no-repeat';
      container.style.backgroundAttachment = 'fixed';
    });
  }, [theme]);

  const toggleTheme = () => {
    setIsTransitioning(true);
    
    // Небольшая задержка для плавного fade эффекта
    setTimeout(() => {
      setTheme(prevTheme => prevTheme === 'dark' ? 'light' : 'dark');
      setTimeout(() => {
        setIsTransitioning(false);
      }, 250);
    }, 50);
  };

  const changeTheme = (newTheme) => {
    if (newTheme === theme) return;
    
    setIsTransitioning(true);
    
    setTimeout(() => {
      setTheme(newTheme);
      setTimeout(() => {
        setIsTransitioning(false);
      }, 250);
    }, 50);
  };

  // Добавляем класс для анимации перехода
  useEffect(() => {
    const root = document.getElementById('root');
    if (isTransitioning) {
      root?.classList.add('theme-transitioning');
    } else {
      root?.classList.remove('theme-transitioning');
    }
  }, [isTransitioning]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

